import { useState } from "react"
import { uploadFile } from "./fileUpload.service"

export const useUploadFile = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const isError = Boolean(error)

  const upload = async (file) => {
    if (!file) {
      const err = new Error("No file provided")
      setError(err)
      throw err
    }

    try {
      setIsLoading(true)
      setError(null)

      const result = await uploadFile(file)
      return result
    } catch (err) {
      console.error("Upload failed:", err)
      setError(err)
      throw err
    } finally {
      setIsLoading(false)
    }
  }

  return { isLoading, isError, error, upload }
}
